// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import FileAttachmentPanel from '../../../../../shared/components/file-attachment-panel';
import {FormattedMessage} from 'react-intl';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PictureRequestFormStruct from '../../../state/picture-request-form';
import ReturnStatusSelect from '../return-status-select';
import {isPictRequestFormInvalid} from '../../../services/is-form-valid';
import {translate} from '../../../../../shared/services/translation-service';

function handleCommentsChange(event) {

    this.onCommentsChange(event.target.value);

}

const PictureRequestForm = props =>
    <section className={`picture-request-form ${props.isEditableAndAccessible ? 'is-editable' : null}`}>
        <ReturnStatusSelect
            errorMessage='PICTURE_REQUEST_STATUS_ERROR'
            fieldLabel='PICTURE_REQUEST_STATUS'
            isEditableAndAccessible={props.isEditableAndAccessible}
            isValid={!(props.pictureRequestForm.returnStatus.id === '7' && props.pictureRequestForm.files.length)}
            onPartReturnStatusChange={props.onPictRequestStatusChange}
            partReturn={props.partReturn}
            returnStatus={props.pictureRequestForm.returnStatus.id}
        />
        <LabeledFormInput
            className={`pict-request-comments ${props.pictureRequestForm.returnStatus.id === '7' ? 'required' : ''}`}
            label='COMMENTS'
        >
            <EditableField
                isEditable={props.isEditableAndAccessible}
                value={props.pictureRequestForm.courierInfo.comments}
            >
                <textarea
                    maxLength={250}
                    onChange={props::handleCommentsChange}
                    value={props.pictureRequestForm.courierInfo.comments}
                />
            </EditableField>
        </LabeledFormInput>
        <FileAttachmentPanel
            displayMessage={translate('FILE_UPLOAD_MESSAGE_IMAGE')}
            files={props.pictureRequestForm.files}
            isRequired={props.pictureRequestForm.returnStatus.id !== '7'}
            isUploadAllowed={props.isEditableAndAccessible}
            onFileDelete={props.onFileDelete}
            onFileUploadSuccess={props.onFileUploadSuccess}
            serviceConfig={{
                className: 'BUS2222',
                classType: 'BO',
                objectKey: `RGA${props.partReturn.rgaNumber}${props.partReturn.claimNumber}`
            }}
        />
        <div className='pict-button-group'>
            <button
                className='button'
                onClick={props.onCancelButtonClick}
            >
                <FormattedMessage id='CANCEL'/>
            </button>
            {props.isEditableAndAccessible &&
                <button
                    className='button-primary'
                    disabled={!props.isFormDirty || isPictRequestFormInvalid(props.pictureRequestForm.returnStatus.id, props.pictureRequestForm)}
                    onClick={props.onSubmitButtonClick}
                >
                    <FormattedMessage id='SUBMIT'/>
                </button>
            }
        </div>
    </section>;

PictureRequestForm.displayName = 'PictureRequestForm';
PictureRequestForm.propTypes = {
    isEditableAndAccessible: PropTypes.bool.isRequired,
    isFormDirty: PropTypes.bool.isRequired,
    onCancelButtonClick: PropTypes.func.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onFileDelete: PropTypes.func.isRequired,
    onFileUploadSuccess: PropTypes.func.isRequired,
    onPictRequestStatusChange: PropTypes.func.isRequired,
    onSubmitButtonClick: PropTypes.func.isRequired,
    partReturn: PropTypes.instanceOf(PartReturn).isRequired,
    pictureRequestForm: PropTypes.instanceOf(PictureRequestFormStruct).isRequired
};

export default PictureRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/picture-request-form/index.js